import { getIsIE } from './getIsIE.js';
import { getIsWindows } from './getIsWindows.js';
import { getFlagEmoji } from './getFlagEmoji.js';

var getMenuControlText = function getMenuControlText(currentCountry) {
  var isIE = getIsIE();
  var isWindows = getIsWindows();
  return "".concat(isWindows || isIE ? '' : "".concat(getFlagEmoji(currentCountry), " ")).concat(currentCountry ? currentCountry : '');
};

export { getMenuControlText };
